import PropTypes from '../../_util/vue-types';
export var ITouchProps = {
  disabled: PropTypes.looseBool,
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.any // onTouchStart: PropTypes.func,
  // onTouchEnd: PropTypes.func,
  // onTouchCancel: PropTypes.func,
  // onMouseDown: PropTypes.func,
  // onMouseUp: PropTypes.func,
  // onMouseLeave: PropTypes.func,

};